var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBalance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 24,
    height: 24,
    fill: "#2255a1",
    viewBox: "0 0 432 432",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M240 278c0-18 8-35 20-48 13-12 30-20 48-20h60c6 0 12-2 16-6s6-9 6-15v-1c0-6-2-11-6-15s-10-7-16-7H53c-14 0-27-6-37-15v202c0 10 4 20 11 27 7 6 16 10 26 10h315c6 0 12-2 16-6s6-9 6-15v-1c0-6-2-11-6-15s-10-7-16-7h-60c-18 0-35-7-48-20-12-12-20-29-20-48zm166-89v180c0 10-4 19-11 26s-16 11-27 11H53c-15 0-28-6-37-15-10-10-16-23-16-38V113c0-15 6-28 15-38h1c9-9 22-15 37-15h41c4 0 8 4 8 8 0 5-4 8-8 8H53c-10 0-19 4-26 10v1c-7 6-11 16-11 26v1c0 9 4 18 11 25s16 11 26 11h315c11 0 20 4 27 11s11 17 11 27v1zm-16 148V219c-6 5-14 7-22 7h-60c-14 0-27 6-36 16-10 9-16 22-16 36 0 15 6 28 16 37 9 9 22 15 36 15h60c8 0 16 3 22 7zm-82-51c-4 0-8-3-8-8 0-4 4-8 8-8h30c5 0 8 4 8 8 0 5-3 8-8 8h-30zM124 105 200 3c2-3 6-4 10-2l61 30c1 0 1 1 2 1l46-31c4-2 9-1 11 3l1 2 30 105c1 4-1 9-5 10H68c-4 0-8-3-8-8 0-4 4-8 8-8h56zm134-63-49-24-65 87h21l93-63zm61-21-125 84h149l-24-84z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBalance);
export default __webpack_public_path__ + "static/media/Balance.077bca83a612ad734522f2859386d52e.svg";
export { ForwardRef as ReactComponent };